export default __webpack_public_path__ + "static/media/office1-before2-1024w.9203e84c.avif";